import {Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import {FacilityView} from '../../models/ApplicationModel';
import {ApplicationService} from '../../shared/services/application.service';
import {FacilityService} from '../../shared/services/facility.service';
import {DataTableDirective} from 'angular-datatables';
import {PreviewModalService} from '../../shared/services/preview-modal.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {AccountService} from '../../services/account.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import * as Constants from '../../models/Constants';
import {ExpiryDateExtension} from '../../models/CommonModels';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { AlertService } from '../../shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-facility-list',
  templateUrl: './facility-list.component.html',
  styleUrls: ['./facility-list.component.css']
})
export class FacilityListComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: true })
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  facilities: FacilityView[] = [];
  catagoryHistoryRef: BsModalRef;
  facilityID: number;
  datepicker: Date;
  minDate: Date;
  maxDate: Date;
  bsValue: Date = new Date();
  bsConfig: Partial<BsDatepickerConfig>;
  expiryExtensionModalRef: BsModalRef;
  comment: string;
  selectedFacilityID: number;
  selectedFacility: FacilityView;

  constructor(private facilityService: FacilityService, private applicationService: ApplicationService, 
    private modalService: BsModalService, private previewService: PreviewModalService, private accountService: AccountService,
    private alertService: AlertService, private spinner: NgxSpinnerService, private errorHandlerService: ErrorHandlerService) { }

  ngOnInit() {
    this.dtOptions = this.facilityService.getDataTableOptions(this.facilities);
    const colorTheme = 'theme-green';
    this.minDate = new Date();
    this.maxDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
    this.maxDate.setDate(this.maxDate.getDate() + 60);//2 months
    this.bsConfig = Object.assign({}, {dateInputFormat: 'MMMM Do YYYY', containerClass: colorTheme });
  }

  getApplicationNumber(facility) {
    return facility.applicationID + facility.applicationNumber;
  }

  getDateString(createdDate){
    let date = new Date(createdDate);
    return date.toLocaleDateString("en-US", {year : 'numeric', month: 'short', day: 'numeric'});
  }

  previewCertificate(applicationId) {
    this.applicationService.previewCertificate(applicationId).subscribe(data => {
      const blob = new Blob([data], {
        type: 'application/pdf'
      });
      this.previewService.openModalFile(blob, 'Licensing Certificate', true);

    });
  }

  catagoryHistoryModal(template: TemplateRef<any>, id: number){
    this.facilityID = id;
    this.catagoryHistoryRef = this.modalService.show(template, Object.assign({}, { class: 'modal-lg' }));
  }

  isUserDirector(){    
    return this.accountService.isUserDirector();
  }

  checkDepartment(productTypeName){
    let deptCodes = this.accountService.getUserDepartmentCodes();
    let facilityDept = "";
    if (productTypeName === Constants.PRODUCT_TYPE_FOOD) {
      facilityDept = Constants.FOOD_DEPARTMENT;
    } else if (productTypeName === Constants.PRODUCT_TYPE_TOBACCO) {
      facilityDept = Constants.TOBACCO_DEPARTMENT;
    } else {
      facilityDept = Constants.MED_DEPARTMENT;
    }

    return this.isUserDirector() && deptCodes.indexOf(facilityDept) > -1;
  }

  isExtendExpirationButtonVisible(facility: FacilityView){
    let appCategoryCode = facility.applicationNumber.match(/[A-Z]+/)[0]
    

    return this.checkDepartment(facility.productTypeName) && facility.isExpired && !facility.isLegacyData &&
      [Constants.APPLICATION_TYPE_CODE_TEMP_COC, Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE, 
      Constants.APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE].indexOf(appCategoryCode) === -1;
  }

  showExtendExpirationModal(template: TemplateRef < any >, facilityId) {
    this.datepicker = null;
    this.selectedFacilityID = facilityId;
    this.selectedFacility = this.facilities.find(f => f.id == this.selectedFacilityID);
    this.expiryExtensionModalRef = this.modalService.show(template, {backdrop: 'static', keyboard: false});
  }

  extendExpirationDate(){
    let data = new ExpiryDateExtension();
    data.facilityID =  this.selectedFacilityID;
    data.applicationID = this.selectedFacility.applicationID;
    data.comment = this.comment;
    data.date = this.datepicker;
    
    this.spinner.show();

    this.facilityService.extendFacilityExpiryDate(data).subscribe(
      resp => {
        this.spinner.hide();
        this.expiryExtensionModalRef.hide();

        if(resp){
          this.alertService.success('Expiration Date Extended Successfuly');
        } else {
          this.alertService.error('Unable to Extend Expiration Date, please try again');
        }
      }, error => {
        this.spinner.hide();
        this.expiryExtensionModalRef.hide();

        let errorMsg = this.errorHandlerService.handleApiError(error);
        this.alertService.error(errorMsg + ' , please try again');
      }, () => {
        this.datepicker = null;
        this.comment = null;
        this.selectedFacilityID = null;
        this.selectedFacility = null;
      }
    )
  }
}
